import { z } from 'zod';

import { TRANSACTION_DIRECTIONS } from '../enums';
import { zId, zMoney, zNonEmptyString, zOptionalString } from './common';

/**
 * Шаблоны операций (F-09).
 *
 * Одни и те же расходы заводятся из месяца в месяц: аренда буткемпа, взнос за
 * турнир, оплата сервера. Каждый раз выбирать кошелёк, категорию и печатать
 * одно и то же описание — работа, которой не должно быть.
 *
 * Шаблон хранит заготовку, а не операцию: сумма и дата остаются за человеком,
 * потому что именно они меняются. Если бы шаблон подставлял и сумму, его
 * пришлось бы заводить заново на каждое изменение цены.
 */

/** Что именно шаблон подставляет в форму. */
export const templatePayloadSchema = z.object({
  direction: z.enum(TRANSACTION_DIRECTIONS),
  walletId: zId.nullish(),
  categoryId: zId.nullish(),
  personId: zId.nullish(),
  counterparty: zOptionalString(120),
  description: zOptionalString(500),
  isPersonCost: z.boolean().default(false),
  /**
   * Сумма необязательна: у аренды она постоянна, у закупки — каждый раз своя.
   * Пустое поле означает «спросить», а не «ноль».
   */
  amountMinor: zMoney.nullish(),
});
export type TemplatePayload = z.infer<typeof templatePayloadSchema>;

export const createTemplateSchema = z.object({
  name: zNonEmptyString(80),
  payload: templatePayloadSchema,
});
export type CreateTemplateInput = z.infer<typeof createTemplateSchema>;

export const updateTemplateSchema = z.object({
  name: zNonEmptyString(80).optional(),
  payload: templatePayloadSchema.optional(),
});
export type UpdateTemplateInput = z.infer<typeof updateTemplateSchema>;

export interface TemplateDto {
  id: string;
  name: string;
  payload: TemplatePayload;
  /** Названия подставляются для показа в списке: без них шаблон безлик. */
  walletName: string | null;
  categoryName: string | null;
  personNickname: string | null;
  usageCount: number;
  createdAt: string;
}
